exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".main-app{background:#f7f3ee}.main-app .shell{max-width:810px}.section-app{padding:50px 0}.section-app .section__container{position:relative}.section-app .section__container:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%}.section-app .section__foot{text-align:center;padding-top:35px}.section-app .section__foot .btn{margin:5px}.section-app .section__notice{font-size:14px;text-align:center;padding-top:10px;font-weight:700}.no-mode-translate-fade-leave-active{transition:all .3s .1s}.no-mode-translate-fade-enter-active{transition:all .4s}.no-mode-translate-fade-enter,.no-mode-translate-fade-leave-active{opacity:0}.no-mode-translate-fade-enter{transform:translateX(31px)}.no-mode-translate-fade-leave-active{transform:translateX(-31px)}@media(max-width:767px){.section-app{padding:30px 0}.section-app .section__foot{padding-top:25px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 395
// module chunks = 0